module.exports = __webpack_public_path__ + "smile1.388fea20c85fa3182733.jpg";


//////////////////
// WEBPACK FOOTER
// /var/www/capzool/temp/src/assets/images/smile1.jpg
// module id = ../../../../../src/assets/images/smile1.jpg
// module chunks = styles